import styled from 'styled-components';

export const StateColumnInner = styled.div``;

export const StatusWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 10px;
`;

export const StatusTitle = styled.div`
  display: flex;
  width: 100%;
  font-size: 16px;
  align-items: center;
  color: #000;

  .loader {
    width: 12px;
    height: 12px;
    margin-right: 5px;
  }

  .indicator {
    width: 12px;
    height: 12px;
    background: #666;
    margin-right: 5px;
    border-radius: 12px;
  }

  .icon {
    font-size: 16px;
    margin-right: 2px;
  }

  &.offline {
    color: #666;

    .indicator {
      background: #666;
    }
  }

  &.online {
    color: #589417;

    .indicator {
      background: #589417;
    }
  }
`;

export const StatusValues = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 10px 0 20px;
`;

export const StatusValue = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 12px;
  padding: 0 0 5px;

  .unit {
    min-width: 80px;
    text-align: right;
  }
`;
